import { Box, Text } from "@mantine/core";
import { CheckIcon } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import classes from "./PasswordRules.module.css";

export interface IPasswordRule {
  key: string;
  label: string;
  done: boolean;
}

export interface PasswordRulesProps {
  password: string;
  confirm: string;
}

export const PASSWORD_MIN = 6;
export const PASSWORD_MAX = 16;

// Canvas 1.5 / 3.2: шаардлагыг маягтын доор шууд шалгаж харуулна (F25).
export function passwordRules(password: string, confirm: string, t: (key: string) => string): IPasswordRule[] {
  return [
    { key: "length", label: t("passwordRules.length"), done: password.length >= PASSWORD_MIN && password.length <= PASSWORD_MAX },
    { key: "match", label: t("passwordRules.match"), done: confirm !== "" && password === confirm },
  ];
}

export function PasswordRules({ password, confirm }: PasswordRulesProps) {
  const { t } = useTranslation("auth");
  const rules = passwordRules(password, confirm, t);

  return (
    <Box component="ul" className={classes.list} aria-label={t("passwordRules.title")} aria-live="polite">
      {rules.map((rule) => (
        <Box component="li" key={rule.key} className={classes.item} data-done={rule.done || undefined}>
          <Box component="span" className={classes.mark} aria-hidden="true">
            {rule.done && <CheckIcon size={12} weight="bold" />}
          </Box>
          <Text span size="sm">
            {rule.label}
          </Text>
        </Box>
      ))}
    </Box>
  );
}
